import { useQuery } from "@tanstack/react-query";
import { subventionService } from "@/features/subventions/services/subvention.service";
import type { UsageHistoryResponse } from "@/features/subventions/types/subvention.types";

// Lazily fetches a perimeter's usage history for a holder — only while the detail drawer is open
// (`enabled`). Cached per (perimeter, holder) so reopening the same card is instant.
export const useSubventionHistory = (
  perimeterId: string | number | null,
  holderId: string | number | null,
  enabled: boolean,
) => useQuery<UsageHistoryResponse>({
  queryKey: ["subvention-history", perimeterId, holderId],
  queryFn: () => subventionService.getUsageHistory(perimeterId as string | number, holderId as string | number),
  enabled: enabled && perimeterId !== null && holderId !== null,
  staleTime: 60_000,
  // The history panel is best-effort: the drawer hides it on error, so a failed fetch must not
  // raise the app's global error toast. Still captured to Sentry (we only suppress the toast).
  meta: { errorConfig: { showToast: false } },
});
